module.exports = __webpack_public_path__ + "img/logogoogle.dddecf9d.png";